<div class="footer-wrapper">
  <div class="footer-row row">
    <div class="copyright-feeds w-100 ">
      <div class="col-md-12">
        <div class="text-center w-100">Copyright © {{ currentYear }} Capital Alliance, All Rights Reserved.</div>
        <div class="text-center w-100 links">
          <a (click)="openDisclaimer()">Disclaimer </a>
        </div>
      </div>
    </div>
  </div>
</div>